"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var about = void 0;

about = function () {
  about.prototype.pressCarousel = function () {
    if (this.$pressObj.length > 0) {
      return setInterval(function (_this) {
        return function () {
          var active = void 0;
          var activeDot = void 0;
          active = $(".press-obj.visible");
          activeDot = $(".dot-list li.active");
          active.removeClass("visible");
          activeDot.removeClass("active");
          return setTimeout(function () {
            if (active.next().length >= 1) {
              active.next().addClass("visible");
              return activeDot.next().addClass("active");
            } else {
              $($(".press-obj")[0]).addClass("visible");
              return $($(".dot-list li")[0]).addClass("active");
            }
          }, 500);
        };
      }(this), 6000);
    }
  };

  function about() {
    this.$pressObj = $(".press-obj");
    this.pressCarousel();
  }

  return about;
}();

exports.default = about;